<div class="modal-header">
  <h4 class="modal-title" translate>GENERATE_EDI_PRICAT</h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="col-12">
    <div class="form-group pb-2">
      <label for="ediConfig" class="control-label" translate>EDI_CONFIGURATION</label>
      <select name="ediConfig" id="ediConfig" class="form-control form-select"
              [(ngModel)]="selectedConfigId" (ngModelChange)="onConfigSelected()" ngbAutofocus>
        <option value="" disabled translate>SELECT_CONFIGURATION</option>
        <option *ngFor="let config of configs" [value]="config.id">
          {{ config.id }} ({{ config.edifactPricatTransformerQualifier }})
        </option>
      </select>
    </div>

    <div class="form-group pb-2" *ngIf="glnOptions.length > 0">
      <label for="buyerGln" class="control-label" translate>BUYER_GLN</label>
      <select name="buyerGln" id="buyerGln" class="form-control form-select" [(ngModel)]="selectedBuyerGln">
        <option [ngValue]="null" disabled translate>SELECT_BUYER_GLN</option>
        <option *ngFor="let gln of glnOptions" [ngValue]="gln.gln">
          {{ gln.gln }}
        </option>
      </select>
    </div>

    <div class="form-group pb-2" *ngIf="glnOptions.length === 0 && selectedConfigId">
      <label for="buyerGlnManual" class="control-label" translate>BUYER_GLN</label>
      <input type="number" class="form-control" name="buyerGlnManual" id="buyerGlnManual"
             [(ngModel)]="selectedBuyerGln" placeholder="{{ 'ENTER_BUYER_GLN' | translate }}">
    </div>

    <div class="alert alert-info" role="alert" *ngIf="isValid()">
      <span translate>EDI_PRICAT_WILL_BE_GENERATED_AND_SAVED</span>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="btn-group btn-group-justified w-100">
    <button class="btn btn-secondary" (click)="cancel()" translate>CANCEL</button>
    <button class="btn btn-primary" [disabled]="!isValid()" (click)="confirm()" translate>GENERATE</button>
  </div>
</div>
